import { render, staticRenderFns } from "./DataImportClassCards.vue?vue&type=template&id=4ea2fc28&scoped=true&"
import script from "./DataImportClassCards.vue?vue&type=script&lang=js&"
export * from "./DataImportClassCards.vue?vue&type=script&lang=js&"
import style0 from "./DataImportClassCards.vue?vue&type=style&index=0&id=4ea2fc28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea2fc28",
  null
  
)

export default component.exports